import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: 'yellow',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },


    },
    //テキスト
      textField: {
        flexGrow: 1,
        height: '100%',
        width: '100%',
        border: 'none',
        backgroundColor: 'transparent',
        textAlign: "center",
    },
  })
);

export const pmlSettingPageStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 316px)',
    },
    paper: {
      background: '#FFFFEE',
    },
  })
);
